import App from './components/App';

export default () => <App />
